module.exports = __webpack_public_path__ + "img/foodSafety-video.b320083a.png";